import CreateAccount from './CreateAccount';

export default CreateAccount;
